import React from "react";
import { Button, TextField, Box, MenuItem, FormLabel } from '@material-ui/core';

interface MappedFilterSelectProps {
    value?: boolean;
    disabled?: boolean;
    onChange: (mapped?: boolean) => void;
    helperText?: string;
    error?: boolean;
}
const ALL_ITEM_KEY = "-";
const MAPPED_ITEM_KEY = "Mapped";
const UNMAPPED_ITEM_KEY = "Not mapped";

const MappedFilterSelect: React.FC<MappedFilterSelectProps> = (props) => {
      

    const getId = (mappedString?: string) : boolean | undefined => {
        if (!mappedString) {
            return undefined;
        }
        if (mappedString === MAPPED_ITEM_KEY) {
            return true;
        } else if (mappedString === UNMAPPED_ITEM_KEY) {
            return false;
        }
        return undefined;
    };

    const onChange = (item: string) : void => {
        if (props.onChange) {
            props.onChange(getId(item));
        }
    };
    var mappedString = ALL_ITEM_KEY;
    if (props.value !== undefined) {
        if (props.value === true) {
            mappedString = MAPPED_ITEM_KEY;
        } else {
            mappedString = UNMAPPED_ITEM_KEY;
        }
    }
    return (
        <TextField
            label="Mapped filter:"
            select
            name="mapped"
            value={mappedString}
            onChange={e => onChange(e.target.value)}
            style={{width:150}}
            helperText={props.helperText}
            error={props.error}
        >
                <MenuItem key={"item_wc"} value={ALL_ITEM_KEY}>
                    {"(All)"}
                </MenuItem>)
                <MenuItem key="item_Mapped" value={MAPPED_ITEM_KEY}>
                    {MAPPED_ITEM_KEY}
                </MenuItem>
                <MenuItem key="item_Unmapped" value={UNMAPPED_ITEM_KEY}>
                    {UNMAPPED_ITEM_KEY}
                </MenuItem>
            </TextField>
    );
};

export default MappedFilterSelect;
